module.exports = __webpack_public_path__ + "static/media/gallery-2.20046a5d.png";